var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2D2D2D",
  stroke: "#FFF",
  d: "m22.5 20.379 5.303-5.304 2.122 2.122L24.62 22.5l5.304 5.303-2.122 2.122L22.5 24.62l-5.303 5.304-2.122-2.122L20.38 22.5l-5.304-5.303 2.122-2.122z"
})));
export default SvgCloseButton;